import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from '@toasttab/buffet-pui-modal'
import React from 'react'
import { Button } from '@toasttab/buffet-pui-buttons'
import { t } from '@local/translations'

export type DeleteAccountModalProps = {
  isOpen: boolean
  onClose: () => void
  onDelete: () => void
}

export const DeleteAccountModal = ({
  isOpen,
  onClose,
  onDelete
}: DeleteAccountModalProps) => {
  return (
    <Modal isOpen={isOpen} onRequestClose={onClose}>
      <ModalHeader>{t('delete-account-modal.delete-my-account')}</ModalHeader>
      <ModalBody>
        {t('delete-account-modal.warning-message')}
      </ModalBody>
      <ModalFooter>
        <Button variant={'destructive'} onClick={onDelete}>
          {t('delete-account-modal.delete-my-account')}
        </Button>
        <Button onClick={onClose}>{t('delete-account-modal.cancel')}</Button>
      </ModalFooter>
    </Modal>
  )
}
